/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AdjustmentType = typeof AdjustmentType[keyof typeof AdjustmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdjustmentType = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
} as const;
